import { createScimToken } from "routes/settings/plugins/scim/controller/create-scim-token"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { showCreatedTokenDialog } from "./created-token-dialog"
import { invalidate } from "lib/graphql/cache"

// SNAG-037: scimBaseUrl comes from getScimEndpoints (the API origin the server actually
// serves SCIM on), NOT from window.location. App and API are separate hosts when deployed,
// so a URL derived from the browser's location sends admins to a host with no /scim/v2.
export async function handleCreateToken({ clientId, scimBaseUrl }) {
    try {
        const result = await createScimToken({ clientId })
        invalidate("getScimTokens")
        await showCreatedTokenDialog(result, scimBaseUrl)
    } catch (error) {
        console.error(error)
        errorSnackbar(error?.message || "Failed to create SCIM token")
    }
}
